import { Config } from '../types';
import keys from './keys';
import contracts from './contracts';
import pools from './pools';
import tokenlists from './tokenlists';
import tokens from './tokens';
import rateProviders from './rateProviders';

const config: Config = {
  key: '91342',
  chainId: 91342,
  chainName: 'GIWA Sepolia',
  name: 'GIWA Testnet Sepolia',
  shortName: 'GIWA Sepolia',
  monorepoName: 'giwa-sepolia',
  slug: 'giwa-sepolia',
  network: 'giwa-sepolia',
  trustWalletNetwork: 'ethereum',
  unknown: false,
  visibleInUI: true,
  testNetwork: true,
  rpc: 'https://sepolia-rpc.giwa.io',
  ws: ``,
  publicRpc: 'https://sepolia-rpc.giwa.io',
  explorer: 'https://sepolia-explorer.giwa.io',
  explorerName: 'Blockscout',
  subgraph: '',
  poolsUrlV2: '',
  subgraphs: {
    main: [''],
    aave: '',
    gauge: '',
    blocks: '',
  },
  bridgeUrl: '',
  supportsEIP1559: true,
  supportsElementPools: false,
  blockTime: 1,
  nativeAsset: {
    name: 'Ether',
    address: '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE',
    symbol: 'ETH',
    decimals: 18,
    deeplinkId: 'ether',
    logoURI: 'tokens/eth.png',
    minTransactionBuffer: '0.005',
  },
  thirdParty: {
    coingecko: {
      nativeAssetId: 'ethereum',
      platformId: 'ethereum',
    },
  },
  addresses: {
    ...contracts,
  },
  pools,
  tokens,
  keys,
  gauges: {
    type: 3,
    weight: 0,
  },
  tokenlists,
  rateProviders,
};

export default config;
